import {
  Box
} from "@mui/material";
import styled from "styled-components";

interface PageCardProps {
  padding:number;
  backgroundRequired: boolean
}

export const PageCard = styled(Box)<PageCardProps>(({ theme, padding, backgroundRequired=true }) => ({
  padding: theme.spacing(padding),
  backgroundColor: (backgroundRequired)? theme.palette.white.main : 'transparent',
  borderRadius: theme.palette.custom.borderRadius,
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(4),
}));